import { render, staticRenderFns } from "./detail-question-list.vue?vue&type=template&id=a563658a&scoped=true&"
import script from "./detail-question-list.vue?vue&type=script&lang=js&"
export * from "./detail-question-list.vue?vue&type=script&lang=js&"
import style0 from "./detail-question-list.vue?vue&type=style&index=0&id=a563658a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a563658a",
  null
  
)

export default component.exports